export default __webpack_public_path__ + "static/media/contact-dark.1415389b.svg";